import { createSlice } from "@reduxjs/toolkit";
import {  fetchSubWorkflowInfoById, ncifResponse,updateDataAndStatusById } from "api/dashboardDetail";

const initialState = {
  _id: "",
  user_status: "",
  next_stage: "",
  popupData: {
    ncif_search_result: "Not Found",
  },
  showSaveAsDraft: false,
  role_id: [],
  user_id : [],
  is_conditional: "",
  successPageContent:""
};
export const popupReducer = createSlice({
  name: "popupReducer",
  initialState,
  reducers: {
    setUserStatus: (state, action) => {
      state.user_status = action.payload;
    },
    setPopupData: (state, action) => {
      state.popupData = {
        ...state.popupData,
        [action.payload.key]: action.payload.value,
      };
    },
    clearPopupData: (state) => {
      state.popupData = {};
    },
    setShowSaveAsDraft: (state, action) => {
      state.showSaveAsDraft = action.payload;
    },
    removeSaveAsDraft: (state) => {
      state.showSaveAsDraft = false;
    },
    setRoleId: (state, action) => {
      state.role_id = [action.payload]
    },
   
    setIsConditional: (state, action) => {
      state.is_conditional = action.payload
    },
    setSuccessPageContent: (state, action) => {
      state.successPageContent = action.payload
    },
    clearSuccessPageContent: (state, action) => {
      state.successPageContent = {}
    },
    setActiveStep: (state, action) => {
      state.activeStep = action.payload
    },
    setUserId: (state, action) => {
      state.user_id = [action.payload]
    },
  },
  extraReducers: (builder) => {
    builder.addCase(ncifResponse.pending, (state,action) => {
      if(state.popupData)
      state.popupData.ncif_search_result = "Not Found";
    });
    builder.addCase(ncifResponse.fulfilled, (state, action) => {
      try{
      if (action?.payload) {
        const { response_message, identification } = action?.payload;
        if (response_message === "Success") {
          if(state.popupData)
          state.popupData.ncif_search_result =
            identification === "Y" ? "Found" : "Not Found";
        } else {
          if(state.popupData)
          state.popupData.ncif_search_result = "Not Found";
        }
      }
    }catch(err){
      console.log(err)
    }})
    builder.addCase(ncifResponse.rejected, (state, action) => {
      // console.log("🚀 ~ builder.addCase ~ action:", action.error)
      });
    builder.addCase(updateDataAndStatusById.fulfilled, (state) => {
      state.workFlowInfoLoading = false;
      state.popupData = {};
    });

    builder.addCase(fetchSubWorkflowInfoById.fulfilled, (state, action) => {
      const userId = JSON.parse(localStorage.getItem("userToken"))?.userId;

      if (!userId) {
        state.popupData = null;
        state.workFlowInfoLoading = false;
        return;
      }

      const keyToFind = `${userId}_${action?.payload?.active_step}`;
      const matchingValue = action?.payload?.unique_values_of?.[keyToFind];

      state.popupData =
        matchingValue &&
        matchingValue.current_step === action?.payload?.active_step
          ? matchingValue
          : null;

      state.workFlowInfoLoading = false;
    });
    
  },
});
// Action creators are generated for each case reducer function
export const { incrementId, decrementId, setPopupData, clearPopupData, setShowSaveAsDraft, removeSaveAsDraft, setRoleId, setIsConditional,setSuccessPageContent,clearSuccessPageContent,setActiveStep,setUserId } = popupReducer.actions;
export default popupReducer.reducer;
